module.exports = __webpack_public_path__ + "img/text1.9643e49f.webp";